module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar fixed-bottom"
  }, [_c('div', {
    staticClass: "container-fluid justify-content-md-center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.location),
      expression: "location"
    }],
    staticClass: "col col-4"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userIsLoging),
      expression: "!userIsLoging"
    }],
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doLogin()
      }
    }
  }, [_vm._v("LOGAR\n\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userIsLoging),
      expression: "userIsLoging"
    }],
    staticClass: "btn btn-dark btn-sm",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doLogoff()
      }
    }
  }, [_vm._v("DESLOGAR\n\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "disabled": !_vm.userIsLoging,
      "text": "PAUSAR ",
      "size": "sm",
      "variant": "info",
      "left": ""
    }
  }, [_vm._l((_vm.pauses), function(pause) {
    return [_c('b-dropdown-item', {
      key: pause.id,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.doPause(pause.id)
        }
      }
    }, [_vm._v(_vm._s(pause.id) + " " + _vm._s(pause.description))])]
  })], 2), _vm._v(" "), (_vm.pabx.status == 2) ? _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pabx.status == 2),
      expression: "pabx.status == 2"
    }],
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doUnPause()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" SAIR DA PAUSA")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col auto text-right"
  }, [_c('label', {
    staticClass: "pr-2"
  }, [_vm._v("Agente:\n\t\t\t\t\t"), _c('span', {
    staticClass: "badge badge-pill badge-secondary"
  }, [_vm._v(_vm._s(_vm.agent))])]), _vm._v(" "), _c('label', {
    staticClass: "pr-2"
  }, [_vm._v("Status:\n\t\t\t\t\t"), _c('span', {
    staticClass: "badge badge-pill badge-info"
  }, [_vm._v(_vm._s(_vm.statusDisplay))])]), _vm._v(" "), _c('label', {
    staticClass: "pr-2"
  }, [_vm._v("Ramal:\n\t\t\t\t\t"), _c('span', {
    staticClass: "badge badge-pill badge-danger"
  }, [_vm._v(_vm._s(_vm.location || 'N/D'))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.location),
      expression: "!location"
    }],
    staticClass: "btn btn-sm",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reloadPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b013d2d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PabxCard.vue
// module id = 740
// module chunks = 7